// extracted by mini-css-extract-plugin
export default {"wrap":"List_wrap__RsM2c","subtitle":"List_subtitle__5hsK+","desc":"List_desc__SLl33"};